import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-submit"
export default class extends Controller {
  connect() {
    this.element.addEventListener("change", this.onChange)
  }
  disconnect() {
    this.element.removeEventListener("change", this.onChange)
  }
  onChange() {
    this.form.requestSubmit();
  }
}
